import { ProductControls } from "@/components/molecules/ProductControl/product-control"
import { FacetsMobile } from "@/components/organisms/Facets/facets-mobile"

export const Header: React.FC<{ title: string; totalHits: number; showFilter: boolean }> = ({
  title,
  totalHits,
  showFilter,
}) => (
  <div className="flex items-center justify-between bg-white py-4 dark:bg-inherit md:top-[84px] md:-mx-12 md:px-12">
    <h1 className="flex items-center gap-1 text-2xl font-normal">
      {title}
      <span className="hidden lg:block">({totalHits})</span>
    </h1>
    <ProductControls showFilter={showFilter} />
  </div>
)

// Mobile Header Component
export const MobileHeader: React.FC<{
  totalHits: number
  disabledFacets?: string[]
  independentFacetDistribution: Record<string, any>
  facetDistribution: Record<string, any>
  currentFilters: {
    categories: string[]
    subcategories: string[]
    rating?: number
    minPrice?: number
    maxPrice?: number
  }
  onFilterChange: (
    newFilters: Partial<{
      categories: string[]
      subcategories: string[]
      rating: number
      minPrice?: number
      maxPrice?: number
    }>
  ) => void
}> = ({
  totalHits,
  disabledFacets,
  independentFacetDistribution,
  facetDistribution,
  currentFilters,
  onFilterChange, 
}) => (
  <div className="top-[141px] z-40 flex items-center justify-between p-2 py-4 dark:bg-transparent lg:hidden">
    <span className="text-gray-500 dark:text-gray-200">{totalHits} results</span>
    <FacetsMobile
      disabledFacets={disabledFacets}
      facetsDistribution={facetDistribution}
      className="w-full min-w-full lg:hidden"
      currentFilters={currentFilters}
      onFilterChange={onFilterChange}
    />
  </div>
)
